// extracted by mini-css-extract-plugin
export default {"brands":"Main_brands__Ii7j+"};